import { gql } from "@/gql/__generated__";
import { useMutation } from "@apollo/client";

const ME_DELETE = gql(`
  mutation meDelete {
    meDelete {
      __typename
      ... on UserDeleted {
        __typename
        id
      }
      ... on UserHasSoleAdminship {
        __typename
        id
      }
      ... on UserNotFound {
        __typename
        id
      }
    }
  }
`);

export function useMeDelete() {
  return useMutation(ME_DELETE);
}
